import type { DivisionState } from './types'
import { DEFAULT_PAGE_ROWS } from 'core/constants'

export const state: DivisionState = {
  divisions: [],
  regions: [],
  selectCompany: {
    company: localStorage.getItem('company') as string,
    region: localStorage.getItem('region') as string,
  },
  selectedDivision: '',
  selectedRows: DEFAULT_PAGE_ROWS,
  currentPage: 1,
}
